import { render, staticRenderFns } from "./TopicNavigationLink.vue?vue&type=template&id=4ea7a904&scoped=true&"
import script from "./TopicNavigationLink.vue?vue&type=script&lang=js&"
export * from "./TopicNavigationLink.vue?vue&type=script&lang=js&"
import style0 from "./TopicNavigationLink.vue?vue&type=style&index=0&id=4ea7a904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea7a904",
  null
  
)

/* custom blocks */
import block0 from "./TopicNavigationLink.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports